/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class SharedSvgKey {
  static readonly ADD_DOCUMENT = 'shared/svg/add-document';
  static readonly DELETE_DOCUMENT = 'shared/svg/delete-document';
  static readonly COPY_DOCUMENT = 'shared/svg/copy-document';
  static readonly SAVE_DOCUMENT = 'shared/svg/save-document';
  static readonly DOWNLOAD_DOCUMENT = 'shared/svg/download-document';
  static readonly MOVE_FORWARD = 'shared/svg/arrow-forward';
  static readonly MOVE_BACKWARD = 'shared/svg/arrow-backward';
  static readonly TOOLS = 'shared/svg/tools';
  static readonly DONE = 'shared/svg/done';
}
